var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Managers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-521.000000, -390.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M522.889795,406 L537.110205,406 C538.56435,406 539.47083,404.428928 538.743758,403.177716 L531.633553,390.93841 C530.90648,389.687197 529.09352,389.687197 528.366447,390.93841 L521.256242,403.177716 C520.52917,404.428928 521.43565,406 522.889795,406 Z M530,399.41467 C529.480662,399.41467 529.05575,398.991327 529.05575,398.473909 L529.05575,396.592386 C529.05575,396.074967 529.480662,395.651624 530,395.651624 C530.519338,395.651624 530.94425,396.074967 530.94425,396.592386 L530.94425,398.473909 C530.94425,398.991327 530.519338,399.41467 530,399.41467 Z M530.94425,403.177716 L529.05575,403.177716 L529.05575,401.296193 L530.94425,401.296193 L530.94425,403.177716 Z",
    id: "warning"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.47e63018fee0e8957078ad50595428b3.svg";
export { ForwardRef as ReactComponent };